<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="8">
                        <v-card-text>
                            <v-card-title class="titulopagina">DETALLE DESPACHO DE HARINA</v-card-title>
                        </v-card-text>
                    </v-col>
                    <v-col cols="1">
                    </v-col>
                    <v-col cols="1">
                        <v-card-title>
                            <v-btn dark small color="green darken-1" @click="guardarDespacho"><v-icon>save</v-icon> Guardar</v-btn>
                        </v-card-title>
                    </v-col>
                    <v-col cols="2">
                        <v-card-title class="float-right">
                            <v-btn dark small color="orange darken-1" @click="volver"><v-icon>arrow_back</v-icon> Volver</v-btn>
                        </v-card-title>
                    </v-col>
                </v-row>
            </v-card-text>
            <table style="width:100%;">
                <thead>
                    <tr>
                        <th class="text-center cabecera">
                            Fecha
                        </th>
                        <th class="text-center cabecera">
                            Patente
                        </th>
                        <th class="text-center cabecera">
                            Turno
                        </th>
                        <th class="text-center cabecera">
                            Folio Destino
                        </th>
                        <th class="text-center cabecera">
                            Bodega Destino
                        </th>
                        <th class="text-center cabecera">
                            Total Maxisacos
                        </th>
                        <th class="text-center cabecera">
                            Peso Total Maxisacos
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-center">
                            {{despacho.fecha |fechaCompleta}}
                        </td>
                        <td class="text-center">
                            <v-text-field label="Patente" v-model="despacho.patente"></v-text-field>
                        </td>
                        <td class="text-center">
                            <v-select
                                :items="turnos"
                                label=""
                                item-value="id"
                                item-text="nombre_turno"
                                v-model="despacho.turnos_id"
                            ></v-select>
                        </td>
                        <td class="text-center">
                            <v-text-field label="Folio Destino" v-model="despacho.folio_destino"></v-text-field>
                        </td>
                        <td class="text-center">
                            <v-select
                                :items="bodegas"
                                label=""
                                item-value="id"
                                item-text="nombre"
                                v-model="despacho.bodegas_destino_id"
                            ></v-select>
                        </td>
                        <td class="text-center">
                            {{despacho.cantidad_jumbos}}
                        </td>
                        <td class="text-center">
                            {{despacho.peso_jumbos}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <table style="width:100%;">
                <thead>
                    <tr>
                        <th class="text-center cabecera">
                            Responsable
                        </th>
                        <th class="text-center cabecera">
                            Guia
                        </th>
                        <th class="text-center cabecera">
                            Folio PCC4
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="text-center">
                            <v-select
                                :items="responsables"
                                label="Responsable"
                                item-value="id"
                                item-text="name"
                                v-model="despacho.responsable_pcc4_id"
                            ></v-select>
                        </td>
                        <td class="text-center">
                            <v-text-field label="Guía" v-model="despacho.guia"></v-text-field>
                        </td>
                        <td class="text-center">
                            <v-text-field label="Folio PCC4" v-model="despacho.folio_pcc4"></v-text-field>
                        </td>
                    </tr>
                </tbody>
            </table>
        </v-card>

        <v-alert
            dense
            text
            type="success"
            v-if="alert"
        >
            {{this.msge}}
        </v-alert>
        <v-alert
            dense
            text
            type="warning"
            v-if="!alert"
        >
            {{this.msge}}
        </v-alert>
        <v-row class="mt-3">
            <v-col>
                <v-card>
                    <v-card-text v-for="l in jumbos_despacho" :key="l.id">
                        <v-row><v-col>{{`LOTE: ${l.nombre}`}}</v-col></v-row>
                        <hr>
                        <v-simple-table dense>
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        Nro Maxisaco
                                    </th>
                                    <th class="text-center">
                                        Barrido
                                    </th>
                                    <th class="text-center">
                                        Eliminar
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="j in l.jumbos" :key="j.id">
                                    <td class="text-center"> {{j.nro_jumbo}} </td>
                                    <td class="text-center"> {{ j.barrido ? " SI" : "-"}} </td>
                                    <td class="text-center">
                                        <v-btn color="red darken-4" dark small icon @click="eliminar(j.id,j.nro_jumbo)">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>       
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <h3>Agregar Maxisacos</h3>
                                <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                            </v-col>
                            <v-col>
                                <v-autocomplete
                                    v-model="lotes_id"
                                    :items="lotes_disponibles"
                                    item-text="nombre_lote"
                                    item-value="id"
                                    label="Seleccione Lote"
                                    color="blue darken-3"
                                    @change="cargarJumbosLote($event)"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th class="text-center">
                                            Nro Maxisaco
                                        </th>
                                        <th class="text-center">
                                            Agregar
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="j in jumbos_disponibles" :key="j.id">
                                        <td class="text-center">{{j.nro_jumbo}}</td>
                                        <td class="text-center">
                                            <v-btn color="green darken-4" dark small icon @click="agregar(j.id)">
                                                <v-icon>add</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table> 
                            </v-col> 
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
export default {
    data:()=>({
        id:null,
        despacho:{},
        jumbos:[],
        turnos:[],
        bodegas:[],
        lotes_disponibles:[],
        lotes_id:null,
        jumbos_disponibles:[],
        alert:false,
        msge:'',
        responsables: []
    }),
    mounted(){
        //console.log(`id: ${this.$route.params.id}`);
        this.id = this.$route.params.id;
        this.cargar_turnos();
        this.buscar_responsables();
    },
    methods:{
        async cargar_despacho(){
            await this.axios.get(`${this.base_url}despacho_harina/${this.id}`,this.headers).then((res)=>{
                //console.log(res.data);
                this.despacho = res.data.despacho;
                this.jumbos = res.data.jumbos;
            }).catch((e)=>{
                console.log(e);
            });
            this.cargar_bodegas();
        },
        async buscar_responsables(){
            await this.axios.get(`${this.base_url}despachos_harina/buscar/responsables`, this.headers).then((res)=>{
                this.responsables = res.data.data;
            }).catch(e=>{
                console.log(e);
            });
        },
        async cargar_bodegas(){
            await this.axios.get(`${this.base_url}bodegas`,this.headers).then((res)=>{
                this.bodegas = res.data.data;
            }).catch(e=>{
                console.log(e);
            });
            this.cargarLotesDisponibles()
        },
        async cargar_turnos(){
            await this.axios.get(`${this.base_url}turnos`,this.headers).then((res)=>{
                this.turnos = res.data.data;
                //console.log('turnos', res.data);
            }).catch((e)=>{
                console.log(e);
            });
            this.cargar_despacho()
        },
        async eliminar(id,nro){
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: `Desea eliminar maxisaco nro ${nro} del despacho ?`,
                okButton: 'Eliminar !!',
            })
            if(okei) {
                await this.axios.post(`${this.base_url}jumbos/${id}/eliminar_despacho`,null,this.headers).then((res)=>{
                    let idx = this.jumbos.findIndex(j => j.id == id);
                    let jumbo = this.jumbos[idx];
                    this.jumbos.splice(idx,1);
                    if(this.lotes_id == jumbo.lotes_id){
                        this.jumbos_disponibles.push(jumbo);
                    }
                    this.cargar_despacho();
                }).catch((e)=>{
                    console.log(e);
                })
            }
        },
        async agregar(id){
            await this.axios.post(`${this.base_url}despacho_harina/${this.despacho.id}/agregar_jumbo`,{maxi_id:id},this.headers).then((res)=>{
                this.cargar_despacho();
                let idx = this.jumbos_disponibles.findIndex(maxi => maxi.id == id);
                this.jumbos_disponibles.splice(idx,1);
            }).catch((e)=>{
                console.log(e);
            })
        },
        async cargarLotesDisponibles(){
            //this.mostrarLoading('Cargando Lotes con Maxisacos disponibles');
            this.mostrarLoading({titulo:'Cargando Lotes coon Maxisacos disponibles...',color:'green'})

            let url = `${this.base_url}lotes/jumbos/disponibles`;
            await this.axios.get(url,this.headers).then((res)=>{
                //console.log('respuesta lotes disponibles', res.data);
                this.lotes_disponibles = res.data.data;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        async cargarJumbosLote(lote_id){
            //this.mostrarLoading('Cargando Maxisacos...');
            this.mostrarLoading({titulo:'Cargando Maxisacos...',color:'green'})

            let url = `${this.base_url}jumbos/disponibles/${lote_id}`;
            await this.axios.get(url,this.headers).then((res)=>{
                //console.log('respuesta jumbos disponibles', res.data);
                this.jumbos_disponibles = res.data.data;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },
        async guardarDespacho(){
            this.mostrarLoading({titulo:'Guardando Despacho ... ',color:'green'})
            await this.axios.put(`${this.base_url}despacho_harina/${this.despacho.id}/actualizar`, this.despacho, this.headers).then((res)=>{
                this.msge = res.data.message;
                this.ocultarLoading();
                this.alert = true;
                this.$router.push({name:'despachos_harina'});
            }).catch(e=>{
                this.ocultarLoading();
                this.msge = e;
                this.errorMessage(e, "Error al Guardar Despacho ");
                this.alert = false;
                console.log(e);
            })
        },
        volver(){
            this.$router.push({name:'despachos_harina'});
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed:{
        ...mapState(['base_url','headers']),
        jumbos_despacho(){
            let lotes = [];
            this.jumbos.forEach(j => {
                let esta = lotes.find(l => l.id == j.lotes_id);
                if(!esta){
                    lotes.push({
                        id:j.lote.id,
                        nombre:j.lote.nombre_lote,
                        jumbos: this.jumbos.filter(ju=>ju.lotes_id == j.lote.id).map(
                            obj => ({id: obj.id, nro_jumbo: obj.nro_jumbo, check:true, barrido: obj.resultado_analisis.barrido	 })
                        )
                    });
                }
            });
            //console.log(lotes);
            return lotes;
        }
    },
    components:{
        ConfirmDialogue
    }
}
</script>
<style scoped>
td{
    padding: 0em 1em;
}
</style>